import styled from 'styled-components'

export const Container = styled.div`
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
`
export const ContainerEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  justify-content: center;

  p {
    margin: 4px;
  }
  img {
    width: 20%;
  }
`
